import Starfield from "./Starfield";

export default function Hero() {
  const goTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="anasayfa" data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#050505]">
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0A0E17] to-[#050505]" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-[#0047FF]/10 blur-[140px]" />
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] rounded-full bg-[#00F0FF]/8 blur-[120px]" />

      <Starfield count={80} />

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true">
        <div className="orbit-ring w-[520px] h-[520px] md:w-[760px] md:h-[760px] relative">
          <span className="orbit-dot -top-[3px] left-1/2" />
        </div>
        <div className="orbit-ring absolute w-[340px] h-[340px] md:w-[520px] md:h-[520px]" style={{ animationDuration: "90s", animationDirection: "reverse" }}>
          <span className="orbit-dot top-1/2 -right-[3px]" style={{ background: "#4d8dff", boxShadow: "0 0 12px #4d8dff" }} />
        </div>
        <div className="orbit-ring absolute w-[820px] h-[820px] hidden md:block" style={{ animationDuration: "120s", borderColor: "rgba(255,255,255,0.05)" }} />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 text-center pt-28 pb-20">
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 border border-cyan-400/25 bg-cyan-400/5 rounded-full px-4 py-1.5 mb-8"
          style={{ animation: "fade-up 0.7s ease forwards" }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
          <span className="text-xs font-medium tracking-wide text-cyan-200">Profesyonel Yayıncı Yönetim Platformu</span>
        </div>

        <h1
          data-testid="hero-title"
          className="font-display font-900 text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-white"
          style={{ animation: "fade-up 0.7s ease 0.1s forwards", opacity: 0 }}
        >
          Yayınını Büyüt,
          <br />
          <span className="text-gradient">Potansiyelini Keşfet</span>
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-7 text-base md:text-lg text-[#A0ABC0] max-w-2xl mx-auto leading-relaxed"
          style={{ animation: "fade-up 0.7s ease 0.2s forwards", opacity: 0 }}
        >
          Hoom Agency ile canlı yayın kariyerini profesyonel destek, kişiye özel yönetim ve sürdürülebilir büyüme
          stratejileriyle bir sonraki seviyeye taşı.
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          style={{ animation: "fade-up 0.7s ease 0.3s forwards", opacity: 0 }}
        >
          <button
            onClick={() => goTo("basvuru")}
            data-testid="hero-apply-button"
            className="btn-glow w-full sm:w-auto text-sm font-semibold text-white px-9 py-4 rounded-full"
          >
            Hemen Başvur
          </button>
          <button
            onClick={() => goTo("hizmetler")}
            data-testid="hero-services-button"
            className="w-full sm:w-auto text-sm font-semibold text-white px-9 py-4 rounded-full bg-black/40 border border-white/15 hover:border-cyan-400/50 hover:text-cyan-200 transition-colors"
          >
            Hizmetleri İncele
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60" aria-hidden="true">
        <div className="w-[1px] h-12 bg-gradient-to-b from-transparent via-cyan-400/60 to-transparent" />
      </div>
    </section>
  );
}
